export default __webpack_public_path__ + "static/media/window.267a455d.svg";